//Please add the language resource
const supplier = {

  msg:{
  }
};
export default supplier



// WEBPACK FOOTER //
// ./src/page/md/supplier/lang/supplier.en.js